import { render, staticRenderFns } from "./settledDetailTabs.vue?vue&type=template&id=e21a12e4&scoped=true&"
import script from "./settledDetailTabs.vue?vue&type=script&lang=js&"
export * from "./settledDetailTabs.vue?vue&type=script&lang=js&"
import style0 from "./settledDetailTabs.vue?vue&type=style&index=0&id=e21a12e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e21a12e4",
  null
  
)

export default component.exports